
export class PartMaster {
    public id: number;
    public itemNumber: string;
    public leadTime: number;
    public description: string;
    public makeBuy: string;
    public unitCost: number;
    public organizationId: number;


    constructor(other?: Partial<PartMaster>) {
        this.id = other?.id || 0;
        this.itemNumber = other?.itemNumber || "";
        this.leadTime = other?.leadTime || 0;
        this.description = other?.description || "";
        this.makeBuy = other?.makeBuy || "";
        this.unitCost = other && other.unitCost?Math.round((other.unitCost+Number.EPSILON)*100)/100: 0;
        this.organizationId = other?.organizationId || 0;
    }
}